export { DetachResponsibleFromLead } from './ui';
